module.exports = __webpack_public_path__ + "static/media/girl.b6e2200b.svg";